import axios from 'axios';
import { loadProgressBar } from 'axios-progress-bar';
import 'axios-progress-bar/dist/nprogress.css';
import { showToastError } from '../components/utils';

const Instance = (config) => {
  const instance = axios.create({
    baseURL: config.baseURL,
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
	    // 'Access-Control-Allow-Origin': '*',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });
  loadProgressBar(null, instance);
  // eslint-disable-next-line no-shadow
  instance.interceptors.request.use((config) => config);

  instance.interceptors.response.use((response) => response.data,
    async (error) => {
      // eslint-disable-next-line no-empty
	    if (error.response && error.response.status === 400) {
	     showToastError(error.response.data.error_message);
	    }
      return Promise.reject(error);
    });
  return instance;
};

export default Instance;
